import React from 'react';
import { Grid } from 'theme-ui';
import PlayWhiteSmall from '~/assets/images/icons/play-white-small.svg';
import CTAButtonWithWrapper from '../CTAButtonWithWrapper';

const CoverButtons = ({ callToAction, contentColor, handleClick, mobileHorizontal }) => {
  return (
    <>
      <Grid sx={{ display: 'grid', rowGap: '3rem' }}>
        {callToAction.map(
          (cta) =>
            !cta.page &&
            !cta.innerLink &&
            !cta.externalLink &&
            !cta.url && (
              <button
                aria-label="Play Video"
                key={cta.id}
                onClickCapture={handleClick}
                sx={{
                  textTransform: 'uppercase',
                  justifySelf: 'left',
                  display: 'block',
                  cursor: 'pointer',
                  fontFamily: 'body',
                  border: 'none',
                  background: 'none',
                  fontSize: '1.6rem',
                  height: 'fit-content',
                  color: contentColor,
                  fontWeight: 'button',
                  padding: 0,
                  margin: 0,
                }}
              >
                <PlayWhiteSmall sx={{ fill: contentColor, mr: '15px' }} />
                {cta.text}
              </button>
            )
        )}

        <Grid
          sx={{
            flex: '0 1',
            gridTemplateColumns: [
              mobileHorizontal ? `repeat(${callToAction.length}, 1fr)` : '1fr',
              `repeat(${callToAction.length}, 1fr)`,
            ],
            justifyItems: 'center',
            gap: '1.6rem',
          }}
        >
          {callToAction.map((cta) => {
            if (cta.page || cta.innerLink || cta.url) {
              return (
                <CTAButtonWithWrapper
                  key={cta.id}
                  sx={{ width: '100%', textAlign: 'center' }}
                  locationDetail={'cover_feature'}
                  aria-label={`Navigate to ${cta?.page?.slug ?? cta.text}`}
                  callToAction={cta}
                />
              );
            }
            return null;
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default CoverButtons;
